import { Injectable } from '@angular/core';
import {
  PaymentRequestDto,
  PaymentMethod,
  PaymentMethodCustomization,
} from '@app/model/payment-request/payment-request.dto';

type ThemeBuilder = {
  subTitle?: string;
  bulletPoints?: string[];
};
@Injectable({
  providedIn: 'root',
})
export class ThemeProviderService {
  private readonly STRING_MAX_LENTH = 45;

  private validateString(value: string): string | false {
    if (!value) {
      return false;
    }

    if (typeof value !== 'string') {
      return false;
    }

    if (value.length > this.STRING_MAX_LENTH) {
      return false;
    }

    return value;
  }

  private buildValidTheme(PaymentMethodCustomization: PaymentMethodCustomization): ThemeBuilder {
    if (!PaymentMethodCustomization) return null;

    const themeBuilder: ThemeBuilder = {};

    if (this.validateString(PaymentMethodCustomization.subTitle)) {
      themeBuilder.subTitle = PaymentMethodCustomization.subTitle;
    }

    if (Array.isArray(PaymentMethodCustomization.bulletPoints)) {
      const validBulletPoints = [];

      for (const bulletPoint of PaymentMethodCustomization.bulletPoints) {
        if (this.validateString(bulletPoint)) {
          validBulletPoints.push(bulletPoint);
        }
      }

      if (validBulletPoints.length > 0) {
        themeBuilder.bulletPoints = validBulletPoints;
      }
    }

    return Object.keys(themeBuilder).length > 0 ? themeBuilder : null;
  }

  getValidatedTheme(
    paymentRequest: PaymentRequestDto,
    paymentType: PaymentMethod
  ): ThemeBuilder | null {
    const customContent =
      paymentRequest?.checkoutUiCustomizations?.paymentMethods?.find(
        (pm) => pm.type === paymentType
      );

    const validTheme = this.buildValidTheme(customContent);
    return validTheme;
  }
}
